import React, { useMemo } from "react";
import MUIDataTable from "mui-datatables";
import { makeStyles } from "@mui/styles";
import {
  Chip,
  CircularProgress,
  Grid,
  Switch,
  Typography,
} from "@mui/material";

const useStyles = makeStyles({});

export default function JobsTable({
  title,
  loading,
  items,
  hiddenColumns = [],
  handleUpdate,
  handleActivate,
}) {
  const classes = useStyles();

  const sortedItems = useMemo(() => {
    return [...items].sort((a, b) => b.JOB_ID - a.JOB_ID);
  }, [items]);

  const columns = [
    {
      name: "JOB_ID",
      label: "#",
    },
    {
      name: "DESCRIPTION",
      label: "Project",
    },
    {
      name: "JOB_DESC",
      label: "Job",
    },
    {
      name: "JOB_STATUS",
      label: "Status",
      options: {
        customBodyRender: (value, tableMeta) => {
          const rowIndex = tableMeta.rowIndex;
          const rowData = items[rowIndex];

          return handleActivate ? (
            <Switch
              checked={Boolean(value)}
              onChange={(e) => handleJobStatusChange(e, rowData)}
              color="primary"
            />
          ) : (
            <Chip
              size="small"
              variant="outlined"
              label={Boolean(value) ? "Active" : "Inactive"}
              color={Boolean(value) ? "primary" : "error"}
            />
          );
        },
      },
    },
  ];

  const options = {
    filter: true,
    filterType: "dropdown",
    responsive: "standard",
    selectableRows: "none",
  };

  const handleJobStatusChange = (event, rowData) => {
    event.stopPropagation();

    const newRowData = {
      ...rowData,
      JOB_STATUS: !Boolean(rowData.JOB_STATUS),
    };

    handleActivate(newRowData);
  };

  return (
    <Grid container>
      <Grid item xs={12}>
        <MUIDataTable
          title={
            <Grid container alignItems="center" spacing={2}>
              <Grid item>
                <Typography variant="h5">{title}</Typography>
              </Grid>
              {loading && (
                <Grid item>
                  <CircularProgress size="1rem" />
                </Grid>
              )}
            </Grid>
          }
          data={sortedItems}
          columns={columns}
          options={options}
        />
      </Grid>
    </Grid>
  );
}
